import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  private cache = new Map<string, any>();

  constructor() {}

  get(key :string) :Observable<any> | undefined {
    return this.cache.has(key) ? of(this.cache.get(key)) : undefined;
  }

  set(key :string, data :any) :Observable<any> {
    this.cache.set(key, data);

    return of(data);
  }

  // Clear the cache when needed
  clear(key ?:string) :void {
    if (key) {
      this.cache.delete(key);
    } else {
      this.cache.clear();
    }
  }
}
